import jQuery from 'jquery';
import React from 'react';
import Button from './ui/button/Button.jsx';
import Configurator from './Configurator.jsx';
import styles from './EnclosureAccessoryTitanConfigurator.styl';
import Image from './ui/features/Image.jsx';
import Table from "./ui/features/Table.jsx";
import ModalPopup from "./ui/features/Modal/Modal.jsx";
import Switch from "./ui/features/InputSwitch.jsx";

/**
 * Конфигуратор аксессуаров для шкафов Titan
 */
class EnclosureAccessoryTitanConfigurator extends Configurator
{
	constructor(props) {
		super(props);
		this.db=null
		this.state = {
			//Списки
			typeAccessory: 'Все',
			enclosure:[],
			bucketList: [],
			accessoryList: [],
			itemList: [],
			openModal:false,
			onTech:false,

			warningText:'',
			filterList: [
				{
					name: 'Серия',
					value: ['Выбрать', 'TITAN 5'],
					selected: 'TITAN 5',
					disabled: false
				},
				{
					name: 'Цвет',
					value: ['Выбрать','RAL 7035(Серый)', 'RAL 3020(Красный)'],
					selected: 'Выбрать',
					disabled: false
				},
				{},
				{
					name: 'Высота',
					value: ['Выбрать', '300',
						'400',
						'500',
						'600',
						'700',
						'800',
						'1000',
						'1200',
						'1400'
					],
					selected: 'Выбрать',
					disabled: true
				},
				{
					name: 'Ширина',
					value: ['Выбрать', '300',
						'400',
						'500',
						'600',
						'800'
					],
					selected: 'Выбрать',
					disabled: true
				},
				{
					name: 'Глубина',
					value: ['Выбрать','150',
						'200',
						'250',
						'300',
						'400'
					],
					selected: 'Выбрать',
					disabled: true
				}
			],
			accessoryFilterList:[
				{ name:'Аксессуары для установки модульных аппаратов', value: false,id:0},{ name:'Дверь внутренняя', value: false,id:1},
				{name:'Козырек защитный', value: false,id:5},{name:'Панель цоколя ЩМП', value: false,id:6},
				{name:'Рейка', value: false,id:7},{name:'Комплект крепления к столбу', value: false,id:8},
				{name:'Фланец кабельный', value: false,id:9},{name:'Ввод кабельный мембранный', value: false,id:10}
			]
		}


		//Кнопки
		this.doPrint = this.doPrint.bind(this);
		this.onBtnExcelClick = this.onBtnExcelClick.bind(this);
		// Обработка событий таблиц
		this.onChangeQuantity = this.onChangeQuantity.bind(this);
		this.addBasket = this.addBasket.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.onCleanFilter = this.onCleanFilter.bind(this)
		this.onOpenModal = this.onOpenModal.bind(this)
		this.showWarning = this.showWarning.bind(this)


		this.calcTotalPrice = this.calcTotalPrice.bind(this);
		this.onFilterChange = this.onFilterChange.bind(this)
		this.onFilterAccessoryList = this.onFilterAccessoryList.bind(this)
		this.onSwitchChange = this.onSwitchChange.bind(this)
		this.onSwitchFilterChange = this.onSwitchFilterChange.bind(this)

	}


	// ++ Для Запуска

	getCustomStyles() {
		return styles;
	}

	getType() {
		return 'enclosure_accessory_titan';
	}

	componentDidMount() {
		this.onLoadDB()
	}

	// -- Для Запуска

	onLoadDB() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db=db
			}
		);
	}


	//Отображение выбранного елемента
	onListItemCheck(item) {
		if (this.state.item && (item.article === this.state.item.article)) {
			return;
		}

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemNSI',
				article: item.article
			},
			items => {
				let onTech=false
				if(items.length===0){
					onTech=true
				}
				this.setState({item: items,onTech,activeArticle:item.article});
			}
		);
	}
	showWarning(warningText){
		this.setState(
			{warningText}, ()=>{
			this.onOpenModal(true)
		})
	}
	onOpenModal(openModal){
		this.setState({openModal})
	}

	// -- Загрузка данных

	// Добавить элемент в корзину
	addBasket(item) {

		let elem = Object.assign({}, item)
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemNSI',
				article: item.article
			},
			items => {
				if(items.length>0){
					elem.price=items[0].price
				}else {
					elem.price='-'
				}
				let warningText=''
				this.setState((prevState) => {
					const bucketList = [...prevState.bucketList]
					const encl=Object.assign({}, prevState.enclosure)
					let newBucketList
					if(bucketList.some(i=>i.article===encl.article)){
						newBucketList=bucketList.map(i=>{
							if(i.article===encl.article){
								if(i.list.some(it=>it.article===elem.article)){
									i.list=i.list.map(it=>{
										if(it.article===elem.article){
											if(+elem.typeId===1||+elem.typeId===2||+elem.typeId===5||+elem.typeId===7||+elem.typeId===8){
												if(+i.count<+it.count+1){
													if(!elem.name.includes('боковая')){
														warningText='Внимание! В один корпус можно установить только одну деталь данного типа'
														return it
													}
												}
											}
											if(+elem.typeId===9){
												if(+encl.width===800){
													if(i.list.filter(itom=>+itom.typeId===9).length===1){
														if(+it.count===2*i.count){
															warningText='Внимание! Вы добавили максимальное количество фланцев'
															return it
														}
													}else {
														if(i.list.reduce((res,itom)=>{if(+itom.typeId===9){
															return res+(+itom.count)
														}else {
															return res
														}},0)>=2*i.count){
															warningText='Внимание! Вы добавили максимальное количество фланцев'
															return it
														}

													}

												}else{

													if(i.list.reduce((res,itom)=>{if(+itom.typeId===9){
														return res+(+itom.count)
													}else {
														return res
													}},0)>=+i.count){
													warningText='Внимание! Вы добавили максимальное количество фланцев'
													return it
													}
												}
											}
											if(+elem.typeId===3||+elem.typeId===11){
												let panelsLMA=i.list.filter(itm=>+itm.typeId===3).reduce((res,itm)=> res+itm.count*150,0)
												let panelsLGN=i.list.filter(itm=>+itm.typeId===11).reduce((res,itm)=> res+itm.count*150,0)
												let panelsLG=i.list.filter(itm=>+itm.typeId===4).reduce((res,itm)=> res+itm.count*50*2,0)
												if(panelsLMA+panelsLG+panelsLGN+150*+i.count>=+encl.height*+i.count){
													warningText='Внимание! Вы добавили максимальное количество панелей'
													return it
												}
											}
											if(+elem.typeId===4){
												let panels=i.list.filter(itm=>+itm.typeId===3||+itm.typeId===11).reduce((res,itm)=> res+itm.count*150,0)
												if(encl.height*i.count-panels-50*2*it.count<=0){
													warningText='Внимание! Вы добавили максимальное количество панелей-заглушек'
													return it
												}
											}
											if(+elem.typeId===6){
												let panel=i.list.find(itm=>itm.name.includes('боковая'))
												if(elem.name.includes('пер/зад')){
													if(+it.count+1>+panel.count){
														warningText='Внимание! Передних и задних панелей цоколя не может быть больше количества боковых панелей цоколя.'
														return it
													}
												}
												if (+it.count===2*i.count){
													warningText='Внимание! Вы добавили максимальное количество панелей цоколя.'
													return it
												}
											}
											if(+elem.typeId===10){
												let res=i.list.filter(itm=>+itm.typeId===10).reduce((res,itm)=> res+(+itm.count),0)
												let flan=i.list.find(itm=>itm.name.includes('отверстием'))
												if(res+1>+flan.count){
													warningText='Внимание! Мембранных вводов кабелей не может быть больше количества фланцев с отверстием.'
													return it
												}
											}


											it.count+=1
											if(it.price==='-'){
												it.sum='-'
											}else {
												it.sum=it.price*it.count
											}
										}
										return it
									}
									)
								}else{

									if(i.list.some(it=>+it.typeId===1)){
										if(+elem.typeId===2||+elem.typeId===7){
											warningText='Внимание! Невозможно установить данную деталь совместно с внутренней дверью'
											return
										}else if(+elem.typeId===3||+elem.typeId===4){
											warningText='Внимание! Для установки данной детали необходимо добавить стойку вертикальную для панелей '
											return
										}
									}else if(i.list.some(it=>+it.typeId===2)){
										if(+elem.typeId===1||+elem.typeId===7){
											warningText='Внимание! Невозможно установить данную деталь совместно с стойкой для панелей'
											return
										}
										if(+elem.typeId===3||+elem.typeId===11){
											let panelsLMA=i.list.filter(itm=>+itm.typeId===3).reduce((res,itm)=> res+itm.count*150,0)
											let panelsLGN=i.list.filter(itm=>+itm.typeId===11).reduce((res,itm)=> res+itm.count*150,0)
											let panelsLG=i.list.filter(itm=>+itm.typeId===4).reduce((res,itm)=> res+itm.count*50*2,0)
											if(panelsLMA+panelsLG+panelsLGN+150>=+encl.height){
												warningText='Внимание! Вы добавили максимальное количество панелей'
												return
											}
										}

									}else if(i.list.some(it=>+it.typeId===7)){
										if(+elem.typeId===1||+elem.typeId===2){
											warningText='Внимание! Невозможно установить данную деталь совместно с рейкой'
											return
										}else if(+elem.typeId===3||+elem.typeId===4||+elem.typeId===11){
											warningText='Внимание! Для установки данной детали необходимо добавить стойку вертикальную для панелей'
											return
										}
									}
									if(+elem.typeId===3||+elem.typeId===4||+elem.typeId===11){
										if (!i.list.some(it=>+it.typeId===2)){
											warningText='Внимание! Для установки данной детали необходимо добавить стойку вертикальную для панелей'
											return
										}
									}
									if(+elem.typeId===9){
										let count=i.list.filter(itom=>+itom.typeId===9)
										if(+encl.width===800){
											if(count.length===1){
												if(+count[0].count===2*i.count){
													warningText='Внимание! Вы добавили максимальное количество фланцев'
													return
												}
											}else if(count.length===2) {
												if(i.list.reduce((res,itom)=>{if(+itom.typeId===9){
													return res+(+itom.count)
												}else {
													return res
												}},0)>=2*i.count){
													warningText='Внимание! Вы добавили максимальное количество фланцев'
													return
												}
											}
										}else{
											if(count.length===1){
												if(i.list.reduce((res,itom)=>{if(+itom.typeId===9){
													return res+(+itom.count)
												}else {
													return res
												}},0)>=+i.count) {
													warningText = 'Внимание! Вы добавили максимальное количество фланцев'
													return
												}
											}
										}
									}
									if(+elem.typeId===7){
                    if(i.list.some(itm=>+itm.typeId===7)){
											warningText='Внимание! Невозможно установить одновременно рейки разного типа'
											return
										}
									}
									if(+elem.typeId===6){
										if(i.list.some(itm=>+itm.typeId===8)){
											warningText='Внимание! У вас уже добавлен комплект крепления к столбу. Панели цоколя предназначены для установки изделия на пол.'
											return
										}
										if(elem.name.includes('пер/зад')){
											if (!i.list.some(itm=>itm.name.includes('боковая'))){
												warningText='Внимание! Передние и задние панели цоколя возможно установить только при наличии боковых панелей цоколя'
												return
											}
										}
									}
									if(+elem.typeId===8){
										if(i.list.some(itm=>+itm.typeId===6)){
											warningText='Внимание! У вас уже добавлены панели цоколя для установки изделия на пол.'
											return
										}
									}
									if(+elem.typeId===10){
										let res=i.list.filter(itm=>+itm.typeId===10).reduce((res,itm)=> res+(+itm.count),0)
										let flan=i.list.find(itm=>itm.name.includes('отверстием'))
										if(!i.list.some(itm=>itm.name.includes('отверстием'))){
											warningText='Внимание! Для установки данной детали необходимо добавить фланец кабельный с отверстием.'
											return
										}
										if(+res+1>+flan.count){
											warningText='Внимание! Мембранных вводов кабелей не может быть больше количества фланцев с отверстием.'
											return
										}
									}

										elem.count=1
									  elem.enclosure=encl.article
										if(elem.price==='-'){
											elem.sum='-'
										}else {
											elem.sum=+elem.price*+elem.count
										}
										i.list.push(elem)

								}
							}else{

							}
							return i
						})

					}else{
						elem.count=1
						elem.enclosure=encl.article
						if(elem.price==='-'){
							elem.sum='-'
						}else {
							elem.sum=+elem.price*+elem.count
						}
						if(+elem.typeId===3||+elem.typeId===4||+elem.typeId===11){
								warningText='Внимание! Для установки данной детали необходимо добавить стойку вертикальную для панелей '
								return
						}
						if(+elem.typeId===6){
							if(!elem.name.includes('боковая')){
									warningText='Внимание! Передние и задние панели цоколя возможно установить только при наличии боковых панелей цоколя'
									return
							}
						}
						if(+elem.typeId===10){
							warningText='Внимание! Для установки данной детали необходимо добавить фланец кабельный с отверстием '
							return
						}

						encl.list=[].concat([elem])
						encl.count=1
						if(encl.price==='-'){
							encl.sum='-'
						}else {
							encl.sum=+encl.price*+encl.count
						}

						bucketList.push(encl)
					}
					return{ bucketList}
				}, () => {

					this.doAddToCart(this.state.bucketList)
					if(warningText){
						this.showWarning(warningText)
					}else {
						this.onListItemCheck(elem)
					}

				});

			}
		);

	}

	//Удаление
	onDelete(item, type) {
			this.setState((prevState) => {
				let newBucketList
				if(item.hasOwnProperty('width')){
					 newBucketList = prevState.bucketList.filter((el) => el.article !== item.article || el.id !== item.id)
				}else{
					newBucketList = prevState.bucketList.map(it=>{
						if(item.enclosure===it.article){
							it.list=it.list.filter((el) => el.article !== item.article || el.id !== item.id)
							if(+item.typeId===2){
								it.list=it.list.filter((el) => el.typeId !== 3 && el.typeId !== 4 )
							}
							if(+item.typeId===6){
								if(item.name.includes('пер/зад')){
									it.list=it.list.filter((el) => el.typeId !== 6 )
								}
							}
							if(+item.typeId===9){
								if(item.name.includes('отверстием')){
									it.list=it.list.filter((el) => el.typeId !== 10 )
								}
							}

							return it
						}else {
							return it
						}
					})
				}

				return {
					...prevState,
					bucketList: newBucketList,

				}
			}, () => {
				this.doAddToCart(this.state.bucketList)
			})

	}

	// изменение количества позиции
	onChangeQuantity(item, value, type) {
		let warningText=''
			this.setState(prevState => {
				let newBasket = prevState.bucketList.map(i => {
					if (i.article === item.article) {
						i.list=i.list.map(it=>{
								it.count = Math.ceil(it.count*value/i.count)
							if(it.price!=='-'){
								it.sum = (+it.count)*(+it.price)
							}
							return it
						})
						i.count = +value
						i.sum = i.price * i.count
					} else if(i.article===item.enclosure){
						i.list=i.list.map((itm,id,arr)=>{
							if(itm.article===item.article){
								if(+item.typeId===1||+item.typeId===2||+item.typeId===5||+item.typeId===7||+item.typeId===8){
									if(+i.count<+value){
										if(!item.name.includes('боковая')){
											warningText='Внимание! В один корпус можно установить только одну деталь данного типа'
											return itm
										}
									}
								}
								if(+item.typeId===9){
									if(+i.width===800){
										if(i.list.filter(itom=>itom.typeId===9).length===1){
											if(+value>2*i.count){
												warningText='Внимание! Вы добавили максимальное количество фланцев'
												return itm
											}else {
												let index=[]
													i.list.map((itom,idx)=>{
													if(itom.name.includes('Ввод')){
													index.push(idx)
												}})
												if(+value<+itm.count){
													if (index.length===1){
														arr[index[0]].count=+value
													}else if(index.length===2 ) {
														arr.splice(index[1],1)
													}
												}
											}
										}else{
											warningText='Внимание! Вы добавили максимальное количество фланцев'
											return itm
										}

									}else if(i.count<value){
										warningText='Внимание! Вы добавили максимальное количество фланцев'
										return itm
									}
								}
								if(+item.typeId===3||+item.typeId===11){
									let panelsLMA=i.list.filter(itom=>+itom.typeId===3||+itom.typeId===11).reduce((res,itom)=>{
										if(itom.article===item.article){
											return res+value*150
										}else{
										 return res+itom.count*150
										}
									} ,0)
									let panelsLG=i.list.filter(itom=>+itom.typeId===4).reduce((res,itom)=> res+itom.count*50*2,0)
									if(panelsLMA+panelsLG>=i.height*i.count){
										warningText='Внимание! Вы добавили максимальное количество панелей'
										return itm
									}
								}
								if(+item.typeId===4){
									let panels=i.list.filter(itom=>+itom.typeId===3||+itom.typeId===11).reduce((res,itom)=> res+itom.count*150,0)
									if(i.height*i.count-panels-50*2*value<-50){
										warningText='Внимание! Вы добавили максимальное количество панелей-заглушек'
										return itm
									}
								}
								if(+item.typeId===6){
									let panel=i.list.find(itom=>itom.name.includes('боковая'))
									if(item.name.includes('пер/зад')){
										if(+value>+panel.count){
											warningText='Внимание! Передних и задних панелей цоколя не может быть больше количества боковых панелей цоколя.'
											return itm
										}
									}
									if (+value>2*i.count){
										warningText='Внимание! Вы добавили максимальное количество панелей цоколя.'
										return itm
									}else {
										let index = i.list.findIndex(itom => itom.name.includes('боковая'))
										arr[index].count = +value
									}
								}
								if(+item.typeId===10){
									let res=i.list.filter(itom=>itom.typeId===10).reduce((res,itom)=>{
									if(itom.article===item.article){
										return res+(+value)
									}else{
										return res+(+itom.count)
									}},0)
									let flan=i.list.find(itom=>itom.name.includes('отверстием'))
									if(+res>+flan.count){
										warningText='Внимание! Мембранных вводов кабелей не может быть больше количества фланцев с отверстием.'
										return itm
									}
								}
								itm.count = +value
								if(itm.price==='-'){
									itm.sum='-'
								}else {
									itm.sum=+itm.price*+itm.count
								}
							}
							return itm
						})
					}

					return i
				})
				return {
					bucketList: newBasket
				}
			}, () => {
				this.doAddToCart(this.state.bucketList)
				if(warningText){
					this.showWarning(warningText)
				}
			})

	}

// -- Работа таблиц


	calcTotalPrice() {
		return this.state.bucketList.reduce((sum, item) =>{
			let value=item.list.reduce((summ, i)=>{
				if(i.price==='-'){
					return summ
				}else {
					return (Math.round(100 * (+i.price * +i.count + summ)) / 100)
				}
				}, 0)
			if(item.price==='-'){
				return sum+value
			}else {
				return (Math.round(100 * (+item.price * +item.count + sum +value)) / 100)
			}
			}, 0)
	}

	// ++ Обработка событий




	// ++Кнопки
	getCustomButtons() {
		let elements = [];

		elements.push(
			<Button
				x="838"
				y="774"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="533"
				y="774"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				onClick={this.onBtnPrintClick}
				key="print"
			/>
		);

		elements.push(
			<Button
				x="1144"
				y="774"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.excelBtnIcon}
				text="Сохранить в Excel"
				onClick={this.onBtnExcelClick}
				key="excel"
			/>
		);


		return elements;
	}


	// ++ Обработка печати
	doPrint(params) {
		let _params = params || {};

		_params.data = {
			specList: JSON.stringify(this.state.bucketList)
		};

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	onFilterChange(id, value, typeId) {
		let filterList = this.state.filterList
		let accessoryFilterList=[...this.state.accessoryFilterList]
		let base=this.db['list']['enclosure_titan']
		let typeAccessory='Все'
		let accessoryList= this.state.accessoryList
		let item
		if(id<5){
	  if(value!=='Выбрать'){
			filterList[id===1?id+2:id+1].disabled=false
				filterList=filterList.map((i,index)=>{
					if(index===2){
						return i
					}
					if(index>id){
						i.selected='Выбрать'
					}
					if(index>id+1&&id!==1){
						i.disabled=true
						i.selected='Выбрать'
					}
					if(index>id+2&&id===1){
						i.disabled=true
						i.selected='Выбрать'
					}


					return i
				})
			}	else {
				filterList=filterList.map((i,index)=>{
					if(index>id){
						i.disabled=true
						i.selected='Выбрать'
					}
					return i
					})
			 }
			accessoryList=[]
				item=[]
    }
		if (id===0){
			let filterValue=base.filter(i=>value.trim()===i.series.trim())
			let result=filterValue.reduce((acc,item)=>{if(acc.includes(item.color)){return acc}else {return [...acc,item.color]}},[])
			filterList[1].value=['Выбрать'].concat(result)
		}
		 if(id===1){
			 let filterValue=base.filter(i=>filterList[0].selected.trim()===i.series.trim()&&value.trim()===i.color.trim())
			 let result=filterValue.reduce((acc,item)=>{if(acc.includes(item.height)){return acc}else {return [...acc,item.height]}},[])
			 filterList[3].value=['Выбрать'].concat(result)
		 }
		if(id===3){
			let filterValue=base.filter(i=>filterList[0].selected.trim()===i.series.trim()&&filterList[1].selected.trim()===i.color.trim()&&+value===+i.height)
			let result=filterValue.reduce((acc,item)=>{if(acc.includes(item.width)){return acc}else {return [...acc,item.width]}},[])
			filterList[4].value=['Выбрать'].concat(result)
		}
		if(id===4){
			let filterValue=base.filter(i=>filterList[0].selected.trim()===i.series.trim()&&filterList[1].selected.trim()===i.color.trim()&&+filterList[3].selected===+i.height&&+value===+i.width)
			let result=filterValue.reduce((acc,item)=>{if(acc.includes(item.depth)){return acc}else {return [...acc,item.depth]}},[])
			filterList[5].value=['Выбрать'].concat(result)
		}

		this.setState(prev => {
			 accessoryFilterList=accessoryFilterList.map(i=>{
				 i.value=false
				 return i
			 })


			let newFilterList = filterList.map((i, index) => {
				if (id === index) {
						i.selected = value
				}
				return i
			})
			return {filterList: newFilterList,typeAccessory, accessoryList,item,onTech: false,accessoryFilterList,itemList:[]}
		}, () => {
			if(this.state.filterList.every(i=>i.selected!=='Выбрать')){
				this.onFilterAccessoryList(this.state.filterList)
			}
		})
	}
	onSwitchChange(id){
		if(this.state.filterList.every(i=>i.selected!=='Выбрать')){
			let switchList=[...this.state.accessoryFilterList]
			let warningText=''
			switchList=switchList.map((i,index,arr)=>{
				if(+id===index){
					i.value=!i.value
				}
				if((+id===4&&index===4&&arr[1].value===true&&i.value===true)||(+id===1&&index===1&&arr[4].value===true&&i.value===true)){
					warningText='Внимание! Нельзя одновременно установить рейку и внутреннюю дверь в один корпус!'
					i.value=!i.value
				}
				if((+id===4&&index===4&&arr[0].value===true&&i.value===true)||(+id===0&&index===0&&arr[4].value===true&&i.value===true)){
					warningText='Внимание! Нельзя одновременно установить рейку и аксессуары для установки модульных аппаратов в один корпус!'
					i.value=!i.value
				}
				if((+id===1&&index===1&&arr[0].value===true&&i.value===true)||(+id===0&&index===0&&arr[1].value===true&&i.value===true)){
					warningText='Внимание! Нельзя одновременно установить аксессуары для установки модульных аппаратов и внутреннюю дверь в один корпус!'
				}

				return i
			})
			this.setState({accessoryFilterList:switchList},()=>{
				this.onSwitchFilterChange(this.state.accessoryFilterList,this.state.accessoryList)
				if(warningText){
					this.showWarning(warningText)
				}
			})

		}else {

			this.showWarning('Для добавления аксессуаров необходимо заполнить все параметры шкафа!')
		}

	}
	onSwitchFilterChange(filterList,itemList){
		let arrId=[]
			filterList.map((i)=>{
			if(i.value){
				if(+i.id===0){
					arrId.push(2,3,4,11)
				}else {
					arrId.push(i.id)
				}

			}
		})
		itemList=itemList.filter(i=>arrId.includes(+i.typeId))
		this.setState({itemList})
	}


	onFilterAccessoryList(filterList) {
		this.setState((prev) => {
				let db = this.db
				let enclosure = db['list']['enclosure_titan'].find(i => filterList[0].selected.trim() === i.series.trim() && filterList[1].selected.trim() === i.color.trim() && +filterList[3].selected === +i.height && +filterList[4].selected === +i.width && +filterList[5].selected === +i.depth)
        let bucketList=[...prev.bucketList]
				jQuery.getJSON(
					'itkcfg.php',
					{
						type: this.getType(),
						action: 'getItemNSI',
						article: enclosure.article
					},
					item => {
						let onTech=false
						enclosure.list=[]
						if(item.length===0){
							enclosure.price='-'
							onTech=true
						}else{
							enclosure.price=item[0].price
						}
						enclosure.count=1
						enclosure.sum=enclosure.price
						bucketList.push(enclosure)
						this.setState({item,onTech,bucketList,activeArticle:enclosure.article})
					});

			let accessoryArticle=db['list']['enclosure_titan_enclosure2accessory'].filter(i=>i['enclosure_article'].toLowerCase().trim()===enclosure.article.toLowerCase().trim())
			accessoryArticle=accessoryArticle.map(i=>{return i['accessory_article']})
			let accessoryList=db['list']['enclosure_titan_accessory'].filter(i=>accessoryArticle.includes(i.article))
			function sortList(a, b) {
				return a.typeId - b.typeId;
			}
			accessoryList=accessoryList.sort(sortList)

			if(this.state.typeAccessory!=='Все'){
				accessoryList=accessoryList.filter(i=>+i.typeId===+this.state.typeAccessory)
			}

			return{enclosure,accessoryList,bucketList}
		}
		)
	}

	onCleanFilter(){
		let filterList=this.state.filterList
		let accessoryFilterList= this.state.accessoryFilterList
		filterList=filterList.map((i,id)=>{
			if(id!==2){
				i.selected='Выбрать'
				if (id>=1){
					i.disabled=true
				}
			}
			return i
		})
		accessoryFilterList=accessoryFilterList.map(i=>{
			i.value=false
			return i
		})
		this.setState({filterList,enclosure:[],typeAccessory:'Все',accessoryList:[],accessoryFilterList,itemList:[], onTech:false})
	}

// -- Обработка печати


	render() {

		let filterStyle ={

			display: 'grid',
			gridTemplateRows: '25px 25px 25px ',
			gridTemplateColumns: '120px 120px 120px',
			maxHeight: '80px',
			width: '200px',
			position: 'absolute',
			zIndex: '100',
			top: "40px",
			left: '20px',
			justifyContent: 'space-evenly',
			gap: '20px'
		}


		return (
			<div className={styles.cfg}>

				{/* Заголовок конфигуратора */}
				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '10%', height: '80px'}}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}

				/>
				{/*Зеленый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#fecd27', width: '100%', height: '80px'}}/>
				<span className={styles.title}>Конфигуратор подбора аксессуаров для корпусов металлических ЩМП TITAN</span>


				<div
					style={{
						position: 'absolute',
						left: '30px',
						top: '100px',
						zIndex: '100'
					}}>

					</div>
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffffff',
					left: '20px',
					width: '440px',
					height: '150px',
					top: '100px',
					zIndex: '1'
				}}>
					<div style={{
						padding: '5px 20px',
						fontSize:'20px',
						marginBottom:'20px',
						color:'#2C4345'
					}}>Введите параметры шкафа:</div>
					<div style={filterStyle}>
						{this.state.filterList.map((i, id) => {
								return (<div key={id+'filter'} style={{
									display: 'grid',
									gridTemplateColumns: '120px',
									gridTemplateRows: '20px 20px	',
									alignItems: 'center'
								}}>{id===2?<div></div>:
									<div style={{
										display: 'grid',
										gridTemplateColumns: '120px',
										gridTemplateRows: '20px 20px	',
										alignItems: 'center'
									}}>
									<div>{i.name}</div>
									<select value={i.selected} disabled={i.disabled} onChange={e => this.onFilterChange(id, e.target.value)}>
									{i.value.length > 0 ? i.value.map((item,index) => {
										return (<option key={id+index+'option'} value={item}>{item}</option>)
									}) : <option value="Все">Все</option>}
								</select>
									</div>
								}

								</div>)
						})}
					</div>

				</div>
				{this.state.openModal&&
					<ModalPopup active={this.state.openModal} setActive={this.onOpenModal} warningText={this.state.warningText}/>
				}

				<div>

							<div style={{position:"absolute",top:'265px',left:'20px',width:'440px',height:'190px',backgroundColor:'#fff'}}>
								<div className={styles.addDeviceLable}>Выбрать тип аксессуара:</div>
								<div style={{display:'grid', marginTop:'40px',gridTemplateColumns:'50% 50%'}}>
								{this.state.accessoryFilterList.map((item,index)=>{
									if(this.state.filterList[1].selected==='RAL 3020(Красный)'){
										if(item.id===9||item.id===10){
                     return
										}
									}
									return(
										<div key={index+'switch'} style={item.id===0?
											{display:"grid",gridTemplateColumns:'86% 14%', marginLeft:'20px',marginTop:'10px',gridColumnStart:'1',gridColumnEnd:'3'}:
											{display:"grid",gridTemplateColumns:'70% 20% 10%', marginLeft:'20px',marginTop:'10px'	}}>
											<span style={{fontSize:'12px'}}>{item.name}</span>
											<Switch  value={item.value} id={index} onChange={this.onSwitchChange}/>
										</div>
										)
								})}</div>


						</div>

					<div style={{
						position: 'absolute',
						top: '227px',
						left: '40px',
						zIndex: '10',
						width: '420px',
					}}>* - необходимо выбрать все фильтры для подбора аксессуаров</div>

					<div style={{
						position: 'absolute',
						top: '460px',
						left: '40px',
						zIndex: '10',
						width: '250px',
					}}>** -для создания новой конфигурации нажмите сбросить фильтр и введите параметры нового шкафа </div>

					<button style={{position: 'absolute', left:'310px', top:'470px', width:'120px', fontSize:'12px',height:'19px'}} onClick={()=>this.onCleanFilter()}>Сбросить фильтр</button>
					{/*Спецификация*/}
					<Table
						title='ПОДОБРАННЫЕ РЕШЕНИЯ'
						items={this.state.itemList}
						styles={{
							width: '440px',
							height: '250px',
							top: '505px',
							left: '20px',
							fontSize: '12px'
						}}
						onSelect={this.onListItemCheck}
						addBasket={this.addBasket}
						activeArticle={this.state.activeArticle}
						configType='enclosure_titan'
					/>
				</div>


				{/*Середина*/}
				{/*Корзина*/}
				{
					<Table
						title='КОРЗИНА'
						type='Bucket'
						items={this.state.bucketList}
						styles={{width: '440px', height: '552px', top: '100px', left: '480px', fontSize: '12px'}}
						onSelect={this.onListItemCheck}
						onDelete={this.onDelete}
						onChangeQuantity={this.onChangeQuantity}
						totalPrice={this.calcTotalPrice()}
						configType='enclosure_titan'
						activeArticle={this.state.activeArticle}
					/>}
				<div style={{position:'absolute', top:'760px',left:'490px',fontSize:'10px'}}>** -в случае отсутствия стоимости - данная позиция является новинкой и скоро поступит в продажу.</div>

				{/* Артикул и название */}
				<div className={styles.itemInfoBG}/>
				{this.state.item && this.state.item[0] ? (
					<a href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.item[0].art}`}
						 target="_blank">
						<div className={styles.itemInfo}>
							<div className={styles.itemInfo_Article}>{this.state.item[0].art}</div>
							<div>{this.state.item[0].name}</div>
						</div>
					</a>
				) : (
					<div className={styles.itemInfoNoArticle}/>
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg + ' ' +
						(this.state.item && this.state.item.length === 0 && this.state.onTech ? styles.warn : '')}
					url={this.state.item && this.state.item[0] && this.state.item[0].ImgPng && this.state.item[0].ImgPng[0].file_ref.uri ? this.state.item[0].ImgPng[0].file_ref.uri : null}
				/>


				{/* Описание */}
				<div style={{
					position: 'absolute',
					top: '452px',
					left: '940px',
					backgroundColor: '#fff',
					width: '434px',
					height: '292px'
				}}/>
				{this.state.item && this.state.item[0] && this.state.item[0].Description && this.state.item[0].Description[0] && this.state.item[0].Description[0].desc_ru ? (
					<div className={styles.description}>
						{this.state.item[0].Description[0].desc_ru}
					</div>
				) : this.state.item && this.state.item.length === 0 && this.state.onTech ? (
						<div className={styles.description}>
							На сайте временно веутся технические работы. Некоторые данные могут быть недоступны
						</div>
					)
					: (
						<div className={styles.descriptionEmpty}>
						</div>
					)}

				{this.getCustomButtons ? this.getCustomButtons() : null}
				{/* На основной сайт IEK */}
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top: '820px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '20px',
					top: '820px',
					left: '700px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '823px',
					left: '415px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target={'_blank'}>Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>

			</div>
		);
	}
}


export default EnclosureAccessoryTitanConfigurator;




// WEBPACK FOOTER //
// ./src/react/EnclosureAccessoryTitanConfigurator.jsx